export default {
  'shenzhen': {
    2020: {
      GAUA: 'UA-103253199-6'
    }
  }
}
